import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { moduleActions } from '../actions/module.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class ModuleEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getModule$ = createEffect(() => {
        return this.actions.pipe(
            ofType(moduleActions.getModule),
            mergeMap(({ id }) => {
                return this.httpService.getModule(id).pipe(
                    // finalizeLoader('library-get-module'), // FIXME: Silent loader required, that does not show up in the UI
                    map((module) => moduleActions.getModuleSuccess({ module })),
                    catchError(() => of(moduleActions.getModuleError({ id }))),
                );
            }),
        );
    });
}
